import api from '@/services/api';
export default () => {
    return new Promise((resolve, reject) => {
        const language = localStorage?.getItem('lang')?.toUpperCase()

        api()({
            url: "/catalog/vehicleMenuList" + `?language=${language}`,
            method: "GET",
        }).then((e) => {
            if (e.data.status == 'false') reject(false);
            resolve(e.data.data)
        }).catch(e => reject(false))
    })
}